import { createContext } from 'react';
import { initialState } from './Messenger.constants';

export const MessengerContext = createContext(initialState);
